import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { Box } from '@mui/material';
import CustomStepper from '../components/common/CustomStepper';
import TextWithPrimaryBlueBackground from '../components/common/TextWithPrimaryBlueBackground';
import BorderedButton from '../components/common/buttons/BorderedButton';
import { useNavigate } from 'react-router-dom';
import { useThemeContext } from '../contexts/BaseThemeContextProvider.js';

export default function OrderThankYouPage({ order }) {
  const navigate = useNavigate();
  const { theme } = useThemeContext();

  return (
    <Grid container spacing={2} sx={{ mt: 5 }}>
      <CustomStepper steps={1} activeStep={1}></CustomStepper>
      <Grid
        item
        xs={12}
        sm={8}
        sx={{ padding: { xs: '0px', md: '16px 32px 0px 0px' }, textAlign: { xs: 'left', sm: 'left', md: 'left' } }}
      >
        <Grid
          item
          xs={12}
          sx={{
            justifyContent: 'flex-start',
            display: { xs: 'flex', sm: 'inherit', md: 'inherit' },
          }}
        >
          <Typography
            sx={{
              paddingBottom: '5px',
              typography: { xs: 'h6', sm: 'h6', md: 'h5' },
              color: theme.custom.orderPFAS.thankyou.color,
            }}
          >
            Order
          </Typography>
          <TextWithPrimaryBlueBackground
            textContent={order}
            sxProps={{ mb: 2, typography: { xs: 'h6', sm: 'h6', md: 'h5' } }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            sx={{
              typography: { xs: 'h4', sm: 'h4', md: 'h3' },
              color: theme.custom.orderPFAS.thankyou.color,
            }}
          >
            Thank you for your order!
          </Typography>
        </Grid>

        <Grid item xs={12} sx={{ paddingBottom: 3, paddingTop: 3 }}>
          <Typography
            variant="body2"
            gutterBottom
            sx={{
              color: theme.custom.orderPFAS.thankyou.color,
            }}
          >
            We have received your order for a home PFAS test kit. We will let you know as soon as the kit is sent out.
            We aim to mail kits within 2 business days.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <BorderedButton buttonText="Go to Home screen" onClick={() => navigate('/')} />
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={4}
        sx={{
          padding: { xs: 0, md: 0 },
          marginTop: { xs: 3, md: 0 },
          textAlign: { xs: 'center', sm: 'left', md: 'left' },
        }}
      >
        <Box
          component="img"
          src="/images/checkout/checkout-thank-you-page.png"
          alt="checkout thank you page"
          sx={{ borderRadius: '16px', width: '100%', height: 'auto', maxWidth: '300' }}
        />
      </Grid>
    </Grid>
  );
}
